import i18next from 'i18next'
import { ProductStatus, ProductType } from '../enums'

export function translateProductType(type: ProductType) {
  switch (type) {
    case ProductType.SMART_ELECTRICAL_CABINET:
      return i18next.t('smartElectricalCabinet', { ns: 'manufacturing' })
    case ProductType.INSTALLATION_KIT:
      return i18next.t('installationKit', { ns: 'manufacturing' })
    case ProductType.PLUG_AND_PLAY:
      return i18next.t('plugAndPlay', { ns: 'manufacturing' })
    case ProductType.SPINE_MODULE:
      return i18next.t('spineModule', { ns: 'manufacturing' })
    case ProductType.VALVE:
      return i18next.t('valve', { ns: 'manufacturing' })
    default:
      return type
  }
}

export function translateProductStatus(status: ProductStatus): string {
  return i18next.t(`ProductStatus.${status}`, { ns: 'manufacturing' })
}
